//@ts-nocheck
import Router, { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { routerConfig } from "../../routers";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input";
import "@banno/jha-wc/src/forms/jha-form-textarea-input/jha-form-textarea-input";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
@customElement("add-ip-whitelist")
export class AddIpWhitelist extends routingMixin(LitElement) {
  static readonly styles = css`
    #btnCon {
      display: flex;
      flex-direction: row;
    }
    @media (prefers-color-scheme: dark) {
      h2 {
        color: #a3d4ff;
      }
    }
    @media (prefers-color-scheme: light) {
      h2 {
        color: #06185f;
      }
    }
    h2 {
      margin-bottom: 18px;
      font-size: 24px;
      font-weight: 600;
    }
    #addIpDiv {
      padding: 24px;
      height: -webkit-fill-available;
      display: flex;
      flex-direction: column;
    }
    jha-card {
      padding: 24px;
      width: -webkit-fill-available;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  `;
  @property({ type: Object })
  formData = {
    businessUnit: "",
    cidrBlock: "",
    portRange: "",
    description: "",
  };

  isFormDirty(): boolean {
    return (
      String(this.formData?.businessUnit ?? "").trim() !== "" ||
      String(this.formData?.cidrBlock ?? "").trim() !== "" ||
      String(this.formData?.portRange ?? "").trim() !== "" ||
      String(this.formData?.description ?? "").trim() !== ""
    );
  }

  private onFieldChange(field: "businessUnit" | "cidrBlock" | "portRange" | "description", e: Event) {
    const value = String((e.target as { value?: string })?.value ?? "");
    this.formData = { ...this.formData, [field]: value };
  }

  async onCancelClick() {
    const leave = () => {
      new Router(routerConfig as any).go("/ip-whitelist");
    };

    // Stub form — dirty is any typed field vs empty defaults.
    // No change → leave silently. Confirm used to open a dialog and then do nothing.
    if (!this.isFormDirty()) {
      leave();
      return;
    }

    const result = await openJhftDialog({
      variant: "warning",
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to leave without saving?",
      cancelLabel: "Stay",
      confirmLabel: "Leave Without Saving",
    });
    if (result === "confirm") {
      leave();
    }
  }
  render() {
    return html`
      <div id="addIpDiv">
        <h1>Add IP Allowlist</h1>
        <jha-card>
          <div>
            <h2>IP Allowlist Information</h2>
            <jha-form-row>
              <jha-form-text-input
                data-auto-id="ipWhitelistNameInput"
                label="Business Unit"
                required
                outline
                maxlength="256"
                .value=${this.formData.businessUnit}
                @input=${(e: Event) => this.onFieldChange("businessUnit", e)}
                @change=${(e: Event) => this.onFieldChange("businessUnit", e)}
              ></jha-form-text-input>
              <jha-form-text-input
                data-auto-id="ipWhitelistCIDRBlockInput"
                label="CIDR Block"
                required
                outline
                maxlength="256"
                .value=${this.formData.cidrBlock}
                @input=${(e: Event) => this.onFieldChange("cidrBlock", e)}
                @change=${(e: Event) => this.onFieldChange("cidrBlock", e)}
              ></jha-form-text-input>
              <jha-form-text-input
                data-auto-id="ipWhitelistPortRangeInput"
                label="Port Range"
                required
                outline
                maxlength="256"
                .value=${this.formData.portRange}
                @input=${(e: Event) => this.onFieldChange("portRange", e)}
                @change=${(e: Event) => this.onFieldChange("portRange", e)}
              ></jha-form-text-input>
            </jha-form-row>
          </div>
          <div>
            <h2>Description</h2>
            <jha-form-row>
              <jha-form-textarea-input
                data-auto-id="ipWhitelistDescriptionInput"
                role="textbox"
                minlength="0"
                maxlength="256"
                required
                label="Description"
                type="text"
                .value=${this.formData.description}
                @input=${(e: Event) => this.onFieldChange("description", e)}
                @change=${(e: Event) => this.onFieldChange("description", e)}
              >
              </jha-form-textarea-input>
            </jha-form-row>
          </div>

          <div style="flex:1;"></div>
          <div id="btnCon">
            <jha-button data-auto-id="addIPWhitelistBtn" type="button" large> Add IP Allowlist </jha-button>
            <jha-button data-auto-id="cancelIPWhitelistBtn" type="button" tertiary large @click=${this.onCancelClick}> Cancel </jha-button>
          </div>
        </jha-card>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "add-ip-whitelist": AddIpWhitelist;
  }
}
